// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yF0y","largestCol":"styles_largestCol__3MbwB","smallestCol":"styles_smallestCol__TVOXF"};